
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { useState, useEffect, useRef } from 'react';
// import { closeCsvDialog } from "../store/csvDialogReducer"
// import useToast from '@fuse/hooks/useToast';
import { toast } from "react-toastify";
// import axios from "@fuse/utils/axios";
import axios from 'axios'
// import Alert from '@material-ui/lab/Alert';
import {Alert} from 'reactstrap'
import { getCsvMappingField, csvUpload, CsvTemplateDownload } from '../api/casp/user';
// import { exportToCsv } from "@fuse/utils";
// import exportExcel from '@fuse/utils/excel';
import { withTranslation } from "react-i18next";
import { ucFirstLetter } from '../helpers/string_helper';
import { Modules } from '../constants/Module';
import { Accordion, AccordionDetails, AccordionSummary, Button, CircularProgress, Divider, FormControl, MenuItem, Select, TextField, Typography } from '@mui/material';
import { Adjust, CheckCircleOutline, Error, ExpandMore } from '@mui/icons-material';

// const useStyles = makeStyles(theme => ({
// 	dropZone: {
// 		border: "4px dashed #999",
// 		padding: 80
// 	},
// 	dropZoneDraging: {
// 		border: "4px dashed #6B2C57",
// 	}
// }));

function CsvUpload(props) {
	const uploadInput = useRef();
	const scrollRef = useRef();
	const [menuProps, setMenuProps] = useState({
		PaperProps: {
			style: {
				height: 130,
				width: 250,
				transform: "translateY(100%)"
			},
		},
		anchorOrigin: {
			vertical: "bottom",
			horizontal: "center"
		},
		transformOrigin: {
			vertical: "bottom",
			horizontal: "center"
		},
		getContentAnchorEl: null
	})
	//const dispatch = useDispatch();
	//const toast = useToast(dispatch);
	//const dialogState = useSelector(({ assetsApp }) => assetsApp.csvDialogReducer);
	const page = {
		UPLOAD_PAGE: 1,
		MAPPING_PAGE: 2,
		SUMMARY_PAGE: 3,
		SUMMARY_DETAILS_PAGE: 4
	}
	const [currentPage, setCurrentPage] = useState(page.UPLOAD_PAGE);
	function goToPage(pageId) {
		setCurrentPage(pageId ?? 1)
	}
	const [loading, setLoading] = useState(false);
	const [uploadedFileInfo, setUploadedFileInfo] = useState({});
	const [isFileSelected, setIsFileSelected] = useState(false);
	const [selectedFile, setSelectedFile] = useState(null);
	const [uploadSummary, setUploadSummary] = useState({});
	const [csvHeader, setCsvHeader] = useState([]);
	const [systemFields, setSystemFields] = useState([]);
	const [dynamicFields, setDynamicFields] = useState([]);
	const [primaryFields, setPrimaryFields] = useState([]);
	// const [allFields, setAllFields] = useState([]);
	const [mappedFields, setMappedFields] = useState([]);
	const [systemRequiredFields, setSystemRequiredFields] = useState([]);
	const [shouldOverwrite, setShouldOverwrite] = useState(false);
	const [uploadErrors, setUploadErrors] = useState([]);
	const [updatedRow, setUpdatedRow] = useState([]);
	const [insertedRow, setInsertedRow] = useState([]);
	const [mappedFieldErrors, setMappedFieldErrors] = useState(null)

	const ondivScroll = () => {
		if (scrollRef.current) {
			const { scrollTop } = scrollRef.current;
			if(scrollTop>=0 && scrollTop<=180){
				setMenuProps({
					...menuProps,
					PaperProps: {
						style: {
							height: 130,
							width: 250,
							transform:"translateY(100%)"
						},
					},
				})
			}
		}
	}

	function handleFileInput(event, file = null) {
		if (!file) {
			file = uploadInput.current.files[0];
		}
		if (!file) {
			return;
		}
		setSelectedFile(file);
		setUploadedFileInfo({ name: file.name, type: file.type, size: file.size });
		setIsFileSelected(true);
	}

	function handleFileUpload() {
		if (!selectedFile) return;
		const mappedData = mappedFields.filter((item) => item.value !== "").reduce((acc, item) => {
			acc[item.field] = item.value === "Create new field" ? "" : item.value
			return acc;
		}, {})
		const formData = new FormData();
		formData.append('file', selectedFile);
		formData.append('mappedData', JSON.stringify(mappedData));
		formData.append('overwrite', shouldOverwrite);
		formData.append('module', props.module)
		setLoading(true);
		csvUpload(formData).then(res => {
			const { data } = res.data;
			// const { summary } = data;
			setUploadSummary(data);
			// if (summary.details && summary.details.length > 0) {
			// 	setUploadErrors(summary.details.sort((el1, el2) => !el2.success ? 1 : -1));
			// }
			setUploadErrors(data.errors)
			setUpdatedRow(data.updatedRow)
			setInsertedRow(data.insertedRow)

			//* Refresh List
			props.onClose(false)
			props.refresh()
			// goToPage(page.SUMMARY_PAGE);
			if (res.statusCode === 200) {
				toast.success(res.data.message);
			}
		}).catch(err => {
			if (err) {
				setMappedFieldErrors(+err.message)
				toast.error(err.message)
			}
			console.log(err)
		}).finally(() => {
			setTimeout(() => {
				setLoading(false);
			}, 1000)
		});
	}

	function handleFieldMapping() {
		if (!selectedFile) return;
	
		const formData = new FormData();
		formData.append("file", selectedFile);
		formData.append("module", props?.module);
	
		setLoading(true);
	
		getCsvMappingField(formData)
			.then(res => {
				const { data } = res.data;
				let {
					csvHeader,
					systemFields,
					dynamic_fields,
					primaryFields,
					all_fields,
					systemRequiredFields,
					fieldMapping
				} = data;
	
				if (props?.module === Modules.PROJECT) {
					csvHeader.shift(); // Adjust for PROJECT module
				}
	
				setCsvHeader(csvHeader);
				setSystemFields(systemFields);
				setPrimaryFields(primaryFields);
				setSystemRequiredFields(systemRequiredFields);
	
				// Combine primary + system fields for sequential assignment
				const combinedFields = [...primaryFields, ...systemFields];
				let usedFields = new Set();
	
				const mapped = csvHeader.map((csvCol, index) => {
					let mappedValue = "";
	
					// If backend mapping exists
					if (fieldMapping && fieldMapping[csvCol]) {
						mappedValue = fieldMapping[csvCol];
						usedFields.add(mappedValue);
					} else {
						// Assign next unused field in order
						const availableField = combinedFields.find(field => !usedFields.has(field.field));
						if (availableField) {
							mappedValue = availableField.field;
							usedFields.add(mappedValue);
						}
					}
	
					return {
						field: csvCol,
						value: mappedValue
					};
				});
	
				setMappedFields(mapped);
				goToPage(page.MAPPING_PAGE);
			})
			.catch(err => {
				if (err) {
					toast.error(err.message);
				}
			})
			.finally(() => {
				setTimeout(() => {
					setLoading(false);
				}, 1000);
			});
	}
	
	

	function handleSetDefaultSettings() {
		setCurrentPage(page.UPLOAD_PAGE)
		setUploadedFileInfo({})
		setIsFileSelected(false)
		setUploadSummary({})
		setShouldOverwrite(false)
		setMappedFieldErrors(null)
	}

	useEffect(() => {
		setSelectedFile(null);
		setTimeout(() => {
			handleSetDefaultSettings();
		}, 200);
	}, [props.open])

	// function capitalize(s) {
	// 	if (typeof s !== 'string') return ''
	// 	return s.charAt(0).toUpperCase() + s.slice(1)
	// }

	// function handleDownloadTemplateFile(filename = "import.csv", blob = null) {
	// 	let link = document.createElement("a");
	// 	if (link.download !== undefined) {
	// 		let url = URL.createObjectURL(blob);
	// 		link.setAttribute("href", url);
	// 		link.setAttribute("download", filename);
	// 		link.style.visibility = 'hidden';
	// 		document.body.appendChild(link);
	// 		link.click();
	// 		document.body.removeChild(link);
	// 	}
	// }

	function handleInitDownload() {
		const url = props.module === Modules.PROJECT ? '/download-csv/project': '/download-csv'
		axios.get(url, 
			{
				responseType: 'blob'
			}
		)
		.then(response => {
			// Use the Blob object as needed (e.g., create a downloadable link)
			const blob = response; // Access the Blob data
			const url = window.URL.createObjectURL(blob);
			const a = document.createElement('a');
			a.href = url;
			a.download = `sample_${props.module === Modules.PROJECT? 'startup' : props.module}_upload_${(new Date()).toISOString().split('T')[0]}`; // Set desired filename
			a.click();
			window.URL.revokeObjectURL(url);
		})
		.catch(error => {
			toast.error(error.message);
		});
	}

	const [isDraging, setIsDraging] = useState(false);

	function handleFileDragOver(event) {
		event.preventDefault();
		if (!isDraging) {
			setIsDraging(true)
		}
	}

	function handleFileDragLeave(event) {
		event.preventDefault();
		if (isDraging) {
			setIsDraging(false)
		}
	}

	function handleFileOnDrop(event) {
		event.preventDefault();
		setIsDraging(false)
		if (event.dataTransfer.files.length) {
			const file = event.dataTransfer.files[0];
			setSelectedFile(file)
			handleFileInput({}, file);
		}
	}

	function CSVFieldMapInput(props) {
		const { fieldValue, fields, itemIndex } = props;
		return (
			<>
				<TextField
					className="mt-3"
					variant="outlined"
					fullWidth
					value={fieldValue}
					inputProps={{
						readOnly: true,
						disabled: true,
					}}
					InputProps={{
						className: 'Mui-disabled text-black'
					}}
					onChange={() => { }}>
				</TextField>
			</>
		)
	}

	function SystemFieldMapInput(props) {
		const { fieldValue, systemFields, itemIndex } = props;
		// const reformatCSVmappingField = (fieldName) => fieldName.split('_').map(str => str === 'id' ? str.toUpperCase() : str.charAt(0).toUpperCase() + str.slice(1)).join(' ')
		return (
			<>
				<FormControl style={{ width: '100%' }}>
					<Select
						className="mt-3 w-100"
						variant="outlined"
						fullWidth
						value={fieldValue}
						onChange={(event) => {
							setMappedFields((mapedItem) => {
								mapedItem[itemIndex] = {
									...mapedItem[itemIndex],
									value: event.target.value
								};
								return [...mapedItem]
							})
						}}
					>
						<MenuItem value="">None</MenuItem>
						<MenuItem disabled>
							<em><strong style={{ fontWeight: 800 }}>Primary fields</strong></em>
						</MenuItem>
						{primaryFields.map((option) => (
							<MenuItem key={option.field}
								value={option.field}
								disabled={mappedFields.map((item) => item.value).includes(option.field)}>

								<span>{option.label}</span><span style={{ color: "red" }}>*</span>

							</MenuItem>
						))}
						<MenuItem disabled>
							<em><strong style={{ fontWeight: 800 }}>System fields</strong></em>
						</MenuItem>
						{systemFields.map((optionField) => (
							<MenuItem key={optionField.field}
								value={optionField.field}
								disabled={mappedFields.map((item) => item.value).includes(optionField.field)}>
								{ optionField.label}{systemRequiredFields.includes(optionField.label) && <span style={{ color: "red" }}>*</span>}
							</MenuItem>
						))}
						{/* {dynamicFields.length && 
							<MenuItem disabled>
								<em><strong style={{fontWeight: 800}}>Custom fields</strong></em>
							</MenuItem>}
						{dynamicFields.length && 
							dynamicFields.map((optionField) => (
								<MenuItem key={optionField} 
									value={optionField}
									disabled={mappedFields.map((item) => item.value).includes(optionField)}>{reformatCSVmappingField(optionField)}
								</MenuItem>
							)
						)} */}
						{/* <MenuItem value="Create new field">
							<span style={{ color: "#388e3c" }}>Create new field</span>
						</MenuItem> */}
					</Select>
				</FormControl>
			</>
		)
	}

	// function handelMappedDataDelete(index) {
	// 	const mappedFieldValue = mappedFields[index].value;
	// 	if (!systemFields.includes(mappedFieldValue)) {
	// 		setMappedFields(item => item.filter((_, itemIndex) => itemIndex !== index));
	// 	} else {
	// 		toast.error("System fields are required");
	// 	}
	// }

	function handleErrorLogDownload() {

		const errorRows = uploadErrors.map(
			el => {
				const row = el.row
				const message = el.errorMessages
				// '2,"lastName is not allowed to be empty,email must be a valid email"'
				return row + ',"' + message.join(' , ').replaceAll("\"", "") + '"'
			}
		)
		// Added Headers
		errorRows.unshift('"Row #","Errors"')
		const csv = errorRows.join('\n')
		const blob =  new Blob([csv], {
			type: "text/csv",
		}); // Access the Blob data
		const url = window.URL.createObjectURL(blob);
		const a = document.createElement('a');
		a.href = url;
		a.download = `upload_error_${(new Date()).toISOString().split('T')[0]}`; // Set desired filename
		a.click();
		window.URL.revokeObjectURL(url);
		// exportExcel(headers, rows, `asset_upload_error_log_${(new Date()).toISOString().split('T')[0]}`);
	}

	return (
		<Dialog
			open={props.open}
			aria-labelledby="form-dialog-title"
			maxWidth="sm"
			fullWidth={true}
			className="list-inline csvUpload"
		>
			<DialogTitle id="form-dialog-title">
				{props.t(`Upload CSV for ${ucFirstLetter(props.module === Modules.PROJECT ? 'Startup' : props?.module)}`)}
				{!loading && currentPage === page.MAPPING_PAGE && (
					<Typography variant="body2" color="textSecondary" style={{
						marginTop: "11px",
						textAlign: "left",
						marginBottom: "-9px",
					}}>
						<span style={{ color: "red" }}>*</span> {props.t("Identify the column with a unique identifier in the file being uploaded as the Primary ID")}
					</Typography>
				)}
			</DialogTitle>
			<DialogContent  ref={scrollRef} onScroll={ondivScroll}>
				{currentPage === page.UPLOAD_PAGE && <>
					<div>
						<div className="text-center" role="button">
							{!loading && <>
								<div style={{
									padding: 80,
									border: `4px dashed ${isDraging ? '#6B2C57' : '#999'}`
								}}
									onClick={() => uploadInput.current.click()}
									onDragOver={handleFileDragOver}
									onDragLeave={handleFileDragLeave}
									onDrop={handleFileOnDrop}
								>
									<CloudUploadIcon sx={{ fontSize: 100 }} color="primary" title={props.t("Upload CSV")}>
										{props.t("cloud_upload")}
									</CloudUploadIcon>
									{isFileSelected && <>
										<p style={{ marginTop: 5 }}>{uploadedFileInfo.name}</p>
										<Button style={{ marginTop: 10 }} onClick={(event) => {
											event.stopPropagation();
											handleFieldMapping();
										}} color="primary" variant="contained">
											{props.t("Upload")}
										</Button>
									</>}
								</div>
							</>}
							{loading && <>
								<CircularProgress />
							</>}
						</div>
						<div className='m-2'>
						<input
							ref={uploadInput}
							className="hidden"
							id="button-file"
							type="file"
							onChange={handleFileInput}
						/>
						</div>
					</div>
				</>}
				{currentPage === page.MAPPING_PAGE && <>
					<div style={{ width: 540 }} >
						<div>
							{!loading && <>
								<div style={{ display: "grid", gridTemplateColumns: "1fr 1fr"}} >
									<div style={{ padding: 5 }}>
										<h4 className="text-center" style={{fontSize:'16px'}}>{props.t("Fields detected in CSV")}</h4>
										{mappedFields.map((({ field }, index) => <div key={index}>
											<div>
												<CSVFieldMapInput fieldValue={field} fields={csvHeader} itemIndex={index} />
											</div>
										</div>))}
									</div>

									<div style={{ padding: 5 }}>
										<h4 className="text-center" style={{fontSize:'16px'}}>{props.t(`Available fields for ${ucFirstLetter(props.module) === ucFirstLetter(Modules.PROJECT) ? 'Startup' : ucFirstLetter(props.module)}s`)}</h4>
										{mappedFields.map((({ value,field }, index) => <div className="w-100" key={index}>
											<div className="w-100">
												<SystemFieldMapInput
													fieldValue={value}
													systemFields={systemFields}
													dynamicFields={dynamicFields}
													itemIndex={index}
												/>
											{mappedFieldErrors === index && <span className="text-danger d-block">{field.replaceAll("*","")} is required</span>}
											</div>
										</div>))}
									</div>
								</div>
							</>}

							{loading && <div className="text-center">
								<CircularProgress />
							</div>}
						</div>
					</div>
				</>}
				{currentPage === page.SUMMARY_PAGE && <>
					<div>
						<div className="pt-2" style={{ padding: '0.5rem 2rem' }}>
							<h4 className="text-center" style={{ marginBottom: 10, color: '#00bf4a' }}>
								<CheckCircleOutline /> {props.t("File uploaded successfully")}
							</h4>

							<Divider style={{ background: '#878787'}} />

							<div style={{ marginLeft: "auto", marginRight: "auto" }}>
								<h6 style={{ marginTop: 10, textAlign: 'center' }}>{uploadedFileInfo.name}</h6>
								<ul className="list-inline statusColors">
									<li style={{ color: '#730a58' }}><Adjust /> {props.t("Total")}: {props.t(uploadSummary.total)}</li>
									<li style={{ color: '#00bf4a' }}><CheckCircleOutline /> {props.t("Created")}: {uploadSummary.create}</li>
									<li style={{ color: '#730a58' }}><CheckCircleOutline /> {props.t("Updated")}: {uploadSummary.update}</li>
									<li style={{ color: '#ff0027' }}><Error /> {props.t("Error")}: {uploadSummary.error}</li>
								</ul>
							</div>

							{(parseInt(uploadSummary.error) > 0 || updatedRow.length > 0 || insertedRow.length > 0 )&& <>
								<div className="text-center viewSummaryButton">
									<Button style={{ marginTop: 5 }} onClick={() => goToPage(page.SUMMARY_DETAILS_PAGE)}  variant="contained">
										{props.t("View summary")}
									</Button>
								</div>
							</>}
						</div>
					</div>
				</>}
				{currentPage === page.SUMMARY_DETAILS_PAGE && <>
					<div className="p-2" style={{ height: 320, overflowY: "auto", overflowX: "hidden" }}>
						{updatedRow.length > 0 && updatedRow.map((row) => (
							<>
							<Alert severity="info" className="w-full" style={{
								padding: 18,
								borderRadius: 4,
								marginBottom: 5,
							}}>
								Row #{row} is successfully updated
							</Alert>
							</>
						))}
						{insertedRow.length > 0 && insertedRow.map((row) => (
							<>
							<Alert severity="success" className="w-full" style={{
								padding: 18,
								borderRadius: 4,
								marginBottom: 5,
							}}>
								Row #{row} is successfully inserted
							</Alert>
							</>
						))}
						{uploadErrors.map((details, index) => (
							<>
								{details.success ?
									details.updated
										? <Alert severity="info" className="w-full" style={{
											padding: 18,
											borderRadius: 4,
											marginBottom: 5,
										}}>
											Row #{details.row_number} is successfully updated
										</Alert>
										: <Alert severity="success" className="w-full" style={{
											padding: 18,
											borderRadius: 4,
											marginBottom: 5,
										}}>
											Row #{details.row_number} is successfully inserted
										</Alert>
									:
									<Accordion
										style={{
											backgroundColor: "rgb(253, 236, 234)",
											padding: 0,
											marginBottom: 5,
										}}>
										<AccordionSummary
											style={{ margin: 0, paddingLeft: 0 }}
											expandIcon={<ExpandMore />}
											aria-controls={`panel${index}a-content`}
											id={`panel${index}a-header`}>
											<Alert severity="error" className="w-full">
												Row #{details.row} has some errors
											</Alert>
										</AccordionSummary>

										<AccordionDetails style={{ display: "block" }}>
											{details.errorMessages.map((error) => (
												<>
													<Typography className="text-danger">
														{error}
													</Typography>
													<br />
												</>
											))}
										</AccordionDetails>
									</Accordion>
								}
							</>
						))}
					</div>
				</>}
			</DialogContent>
			<DialogActions>
				{currentPage === page.SUMMARY_DETAILS_PAGE &&
					<>
						{(parseInt(uploadSummary.error)) > 0 &&  
						<Button onClick={() => handleErrorLogDownload()} color="primary">
							{props.t("Download Error Log")}
						</Button>
                        }
						<Button onClick={() => goToPage(page.SUMMARY_PAGE)} color="primary">
						{props.t("Back")}
						</Button>
					</>}
				{currentPage === page.SUMMARY_PAGE &&
					<>
						<Button onClick={() => goToPage(page.MAPPING_PAGE)} color="primary">
						{props.t("Back")}
						</Button>
					</>}
				{currentPage === page.MAPPING_PAGE &&
					<>
						{/* <div style={{ flex: "auto" }}>
							<FormControlLabel
								control={
									<Checkbox
										checked={shouldOverwrite}
										onChange={(event) => setShouldOverwrite(event.target.checked)}
									/>
								}
								className="ml-5"
								label="Overwrite"
							/>
						</div> */}
						<Button onClick={() => handleFileUpload()} color="primary">
						{props.t("Import")}
						</Button>
						<Button onClick={() => goToPage(page.UPLOAD_PAGE)} color="primary">
						{props.t("Back")}
						</Button>
					</>}
				{currentPage === page.UPLOAD_PAGE &&
					<>
						<Button onClick={handleInitDownload} color="primary">
						{props.t("Download template file")}
						</Button>
					</>}
				<Button onClick={() => props.onClose(false)} color="primary">
					{props.t("Close")}
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default withTranslation()(CsvUpload);